/** Demo stub — no real upload. */
export async function uploadFile(
  _file: File,
  _accessToken: string,
): Promise<{ id: string; url: string }> {
  return {
    id: `file-${Date.now()}`,
    url: '/brand/logo-sm.svg',
  };
}
